import CompanyIntro from './components/CompanyIntro';
import CompanyHistory from './components/CompanyHistory';
import CEOMessage from './components/CEOMessage';
import CompanyValues from './components/CompanyValues';

export default function AboutPage() {
  return (
    <div className="min-h-screen">
      <div className="pt-20">
        <CompanyIntro />
        <CEOMessage />
        <CompanyHistory />
        <CompanyValues />
      </div>
    </div>
  );
}
